const join = (values, separator = ' ') => values.filter(each => !!Boolean(each)).join(separator)

export default join
